import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import ProductCard from "../components/Products/productCardMobile";
import ProductCardDesktop from "../components/Products/productCardDesktop";
import SubCard from "../components/Products/productMiniCard";
import { listProductDetails } from '../flux/actions/product-actions';
import { NotFoundSearch } from './NotFoundSearch';
import Hidden from "@material-ui/core/Hidden";
import ScreenLoader from '../components/ScreenLoader';
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { ProductModel } from "../models/product-model";
import FeaturedProducts from "../components/Products/FeaturedProducts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
  })
);

const Producto: FC = () => {
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const params = useParams();
  const productId = (params as any)?.id;
  const productDetails = useSelector((state: any) => state.productReducer);
  let { product = {} , error, loading } = productDetails;
  const [showScreenLoader, setShowScreenLoader] = useState(false);
  
  useEffect(() => {
      dispatch(listProductDetails(productId, 1));
  }, [productId])

  useEffect(() => {
    setShowScreenLoader(loading);
  },[loading])
  
  useEffect(() => {
    product.isDelete = true;
    window.scrollTo(0,0);
  }, [error])

  return (
  <div>
    { showScreenLoader && <ScreenLoader isOpen={showScreenLoader}/> }
      {product.isDelete ? <NotFoundSearch showScreenLoader={showScreenLoader}/> :
        <Box mt={5} mb={5}>
          <Container>
            <Hidden smDown>
              <ProductCardDesktop />
            </Hidden>
            <Hidden mdUp>
              <ProductCard />
            </Hidden>

            <Box mt={12}>
              <Typography align="center" variant="h4" gutterBottom>
                También te podría interesar
              </Typography>
              <div className={classes.root}>
                <Grid container spacing={3}>
                  <FeaturedProducts />
                </Grid>
              </div>
            </Box>
          </Container>
        </Box>
      }
  </div>
  );
};

export default Producto;
